/* Keep Shopify descriptions authoritative; reorganize existing content without truncating it. */
(() => {
  if (customElements.get('living-content')) return;
  class LivingContent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const source = this.querySelector('[data-living-source]');
      if (!source) return;
      const doc = document.createElement('div');
      doc.innerHTML = source.innerHTML;
      doc.querySelectorAll('meta,script,style').forEach(el => el.remove());
      doc.querySelectorAll('[style],[id],[aria-hidden]').forEach(el => {
        el.removeAttribute('style'); el.removeAttribute('id'); el.removeAttribute('aria-hidden');
      });
      const handle = this.dataset.handle;
      const kind = this.dataset.kind;
      const candle = kind === 'Candles';
      const game = kind === 'Games';
      const greeting = handle.includes('greeting-cards');
      const intro = this.closest('product-info').querySelector('[data-living-intro]');
      const details = document.createElement('div');
      const reading = document.createElement('div');
      // The legacy description panel is the explicit material/specification boundary.
      const original = document.createElement('div');
      original.innerHTML = source.innerHTML;
      const panel = original.querySelector('#scProductDescription');
      if (panel) {
        details.innerHTML = panel.innerHTML;
        panel.remove();
        reading.innerHTML = original.innerHTML;
      } else if (candle) {
        [...doc.children].forEach(el => {
          if (/^(fragrance:|scent:|will burn|burn time)/i.test(el.textContent.trim())) details.append(el);
          else reading.append(el);
        });
      } else if (source.textContent.includes('•') && !game) {
        const parts = source.innerHTML.split('•');
        reading.innerHTML = parts.shift();
        const ul = document.createElement('ul');
        parts.forEach(part => {
          const temp = document.createElement('div'); temp.innerHTML = part;
          const li = document.createElement('li'); li.textContent = temp.textContent.trim();
          if (li.textContent) ul.append(li);
        });
        details.append(ul);
      } else {
        // Unstructured/new descriptions remain complete in the details accordion.
        details.innerHTML = doc.innerHTML;
      }
      let howToUse = false;
      if (game && !panel) {
        const steps = [...details.children];
        const start = steps.findIndex(el => /^(how to use|shuffle|find a peaceful spot)/i.test(el.textContent.trim()));
        if (start >= 0) { steps.slice(start).forEach(el => reading.append(el)); howToUse = true; }
      }
      const intros = {
        'romanticize-your-life-candle': 'A warm glow. A little reminder to fall in love with the everyday.',
        'forgive-yourself-candle': 'A little space to slow down, soften, and begin again.',
        'proud-of-you-mug-1': 'A little encouragement to hold in your hands.',
        'never-a-burden-mug-1': 'A daily reminder that you are loved, just as you are.',
        'you-are-the-most-constant-thing-tweet-mug': 'A quiet reminder to befriend yourself first.',
        'writers-dreamers-candle-bundle': 'Bring your words to life and make your dreams a reality.',
        'i-affirm-affirmation-deck': 'Encouraging messages for a gentler perspective on your inward journey.',
        'affirmation-deck-by-danica-gim': '44 beautifully illustrated affirmation cards to empower your healing heart.',
        'creepy-would-you-rather-cards': '110 macabre questions for horror fans and anyone with a dark side.',
        'super-fast-funny-fun-fact-pocket-trivia': 'A pocket-sized trivia deck for curious minds and good company.'
      };
      let introText = intros[handle] || '';
      const first = reading.querySelector('p');
      const literalWords = ['romanticize-your-life-candle','forgive-yourself-candle','proud-of-you-mug-1','never-a-burden-mug-1','you-are-the-most-constant-thing-tweet-mug'].includes(handle);
      if (!introText && !howToUse && first && !first.querySelector('a') && first.textContent.trim().length < 200) {
        introText = first.textContent.trim(); first.remove();
      }
      if (!introText) introText = game ? 'A little time to connect, reflect, or discover something new.' : candle ? 'Make a little room for your everyday rituals.' : 'A little something for your everyday.';
      intro.textContent = introText; intro.hidden = false;
      // Explicit words-by credits are displayed above the introduction, never inferred from vendor.
      reading.querySelectorAll('p').forEach(p => { if (/^words by\s/i.test(p.textContent.trim())) p.remove(); });
      [details,reading].forEach(container => {
        container.querySelectorAll('meta,script,style').forEach(el => el.remove());
        container.querySelectorAll('[style],[id],[aria-hidden]').forEach(el => {el.removeAttribute('style');el.removeAttribute('id');el.removeAttribute('aria-hidden');});
        container.querySelectorAll('a[href^="/product/"]').forEach(a => a.setAttribute('href',a.getAttribute('href').replace('/product/','/products/')));
      });
      source.replaceChildren(...details.childNodes);
      this.querySelector('[data-living-copy]').replaceChildren(...reading.childNodes);
      this.querySelector('[data-living-details-title]').textContent = candle ? 'SCENT & DETAILS' : game ? 'ABOUT THE DECK' : greeting ? 'CARD DETAILS' : 'DETAILS & CARE';
      this.querySelector('[data-living-reading-title]').textContent = howToUse ? 'HOW TO USE YOUR DECK' : literalWords ? 'READ THE WORDS' : 'ABOUT THIS ITEM';
      this.querySelector('[data-living-details]').hidden = !source.textContent.trim();
      this.querySelector('[data-living-reading]').hidden = !this.querySelector('[data-living-copy]').textContent.trim();
    }
  }
  customElements.define('living-content', LivingContent);
})();
